import * as Sentry from '@sentry/react'

export function emitException(error: Error) {
  if (import.meta.env.MODE !== 'production') {
    throw error
  }

  Sentry.captureException(error)
}
